"use client";

import { useState } from "react";
import { Check } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InteractiveTabs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const tabs = [{
    id: "interior",
    label: "Interior Design",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/interior_design_space.png",
    description: "Our showroom offers a curated selection of high-quality tiles and sanitary ware, allowing clients to experience materials firsthand before making decisions.\n\nProduct categories include:",
    checklist: ["Luxury tiles", "Color palette and material curation", "Lighting design and fixture selection", "Space planning and layout optimization"]
  }, {
    id: "architecture",
    label: "Architecture",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/architectural_planning.png",
    description: "Our architectural services bring visionary concepts to life through innovative design solutions that harmonize aesthetics, sustainability, and structural integrity.",
    checklist: ["Conceptual design and planning", "Premium sanitary ware", "Building code compliance", "Construction documentation"]
  }, {
    id: "renovation",
    label: "Renovation",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/renovation_project.png",
    description: "Transform existing spaces with our comprehensive renovation services, breathing new life into structures while preserving their character and enhancing their value.",
    checklist: ["Complete home remodeling", "Kitchen and bathroom upgrades", "Architectural surfaces", "Historic restoration services"]
  }];
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  return;
}